import React, { useMemo } from "react"
import { useAlgoliaSearch } from "@app/providers/algolia"

interface ResultsProps {
  listStyle: any
  listClassName?: any
  renderNoResults: any
  // renderError: any
  // renderResultCardCallout: any
  renderResultCardProduct: any
  renderPaginationNumbered?: any
  renderLoading: any
}

const Results: React.FC<ResultsProps> = ({
  listStyle,
  listClassName,
  renderNoResults,
  // renderError,
  // renderResultCardCallout,
  renderResultCardProduct,
  renderPaginationNumbered,
  renderLoading,
}) => {
  const { products, isLoading } = useAlgoliaSearch()

  const productRefs = useMemo(() => products?.map(() => ({ current: null } as React.RefObject<HTMLDivElement>)) ?? [], [products])

  if (isLoading || !products) return renderLoading()

  if (products.length === 0) return renderNoResults()

  return (
    <>
      {/* {renderResultCardCallout()} */}
      {/* {renderError()} */}
      <section style={listStyle} className={listClassName}>
        {products.map((product, index) => (
          <React.Fragment key={product.objectID || product.id || index}>
            {renderResultCardProduct({ product, index, productRefs })}
          </React.Fragment>
        ))}
      </section>
      {renderPaginationNumbered && renderPaginationNumbered()}
    </>
  )
}

export { Results }
